<template>
  <Modal
    :width="1025"
    :visible="previewVisible"
    :title="previewTitle"
    :footer="false"
    :cancelButtonProps="{ hidden: true }"
    @cancel="previewVisible = false"
    @ok="onSumbit"
  >
    <div class="material flex">
      <div class="material-left flex-column y-center">
        <div
          class="data-item y-center"
          :class="{ active: classIndex === index }"
          v-for="(item, index) in classList"
          :key="index"
          @click="onNavSwitch(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="material-right flex1">
        <div class="text-list" v-if="num === 2">
          <template v-if="classList[classIndex]">
            <div
              class="text-item flex1"
              v-for="(item, index) in classList[classIndex].module_item"
              :key="index"
            >
              <span>{{ item.content }}</span>
              <div class="x-end">
                <Button class="button" type="primary" @click="onSumbit(item)">插入</Button>
              </div>
            </div>
            <div
              v-if="classList[classIndex].module_item.length === 0"
              class="flex1 flex-column xy-center"
              style="margin: 2vw 0"
            >
              <img src="@/assets/images/empty@2x.png" style="width: 324px; height: 237px" />
              <span style="color: #999">暂无数据</span>
            </div>
          </template>
        </div>
        <div class="image-list flex-wrap" style="height: 450px" v-else>
          <div
            class="image-item"
            :class="{ active: checkList.findIndex((m) => m.uuid === item.uuid) !== -1 }"
            v-for="(item, index) in dataList"
            :key="index"
            @click="onChecked(index)"
          >
            <img mode="aspectFill" class="image-fit" :src="ossUrl + item.image" v-if="num === 0" />
            <img mode="aspectFill" class="image-fit" :src="item.img_urls[0]" v-if="num === 1" />
            <img
              v-if="checkList.findIndex((m) => m.uuid === item.uuid) !== -1"
              src="@/assets/images/select@2x.png"
              style="position: absolute; right: -2px; bottom: -2px; width: 44px; height: 22px"
            />
          </div>
          <div
            v-if="dataList.length === 0"
            class="flex1 flex-column xy-center"
            style="margin: 2vw 0"
          >
            <img src="@/assets/images/empty@2x.png" style="width: 324px; height: 237px" />
            <span style="color: #999">暂无数据</span>
          </div>
        </div>
        <div
          class="xy-center"
          style="margin-top: 20px"
          v-if="num !== 2 && paginationData.total > 0"
        >
          <Pagination
            v-model:current="paginationData.current"
            :pageSize="paginationData.pageSize"
            :total="paginationData.total"
            @change="onPaginationChange"
            @show-size-change="onPaginationChange"
          />
        </div>
        <div class="x-end" v-if="num !== 2 && dataList.length > 0">
          <Button class="button" @click="onSumbit">确定</Button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
  import { Modal, Pagination, Button, message } from 'ant-design-vue';
  import { useGlobSetting } from '@/hooks/setting';
  import defHttp from '@/jslibs/axios/http';

  const globSetting = useGlobSetting();
  const ossUrl = globSetting.ossUrl;

  export default {
    name: 'AIMaterial',
    components: {
      Modal,
      Pagination,
      Button,
    },
    data() {
      return {
        previewVisible: false,
        previewTitle: '插入素材',
        classList: [],
        classIndex: 0,
        dataList: [],
        paginationData: {
          current: 1,
          pageSize: 6,
          total: 0,
          loading: false,
          searchText: '',
        },
        checkList: [],
        num: 0,
        urls: [
          [`插入素材`, `/v1/cms/MaterialClass`, `/v1/cms/MaterialMain`],
          [`插入图片引擎`, `/v1/cms/MaterialMainFollow`, `/v1/cms/MaterialMainFollow`],
          [`我收藏的内容引擎`, `/v1/cms/MaterialMainFollow`, `/v1/cms/MaterialMainFollow`],
        ],
      };
    },
    methods: {
      getClass() {
        return defHttp
          .get({
            url: this.urls[this.num][1],
          })
          .then((res) => {
            this.classList = res.result.data;
            this.classIndex = 0;
          });
      },
      getList() {
        let class_uuid = '';
        if (this.classList[this.classIndex]) {
          class_uuid = this.classList[this.classIndex].uuid;
        }
        if (!class_uuid) return false;
        const params = {};
        if (this.num === 0) {
          params['class_uuid'] = class_uuid;
        } else if (this.num === 1) {
          params['tag'] = class_uuid;
          params['type'] = 2;
        }
        defHttp
          .get({
            url: this.urls[this.num][2],
            params: {
              page_index: this.paginationData.current,
              page_size: this.paginationData.pageSize,
              keyword_search: this.paginationData.searchText,
              ...params,
            },
          })
          .then((res) => {
            this.dataList = res.result.data;
            this.paginationData.current = res.result.current_page;
            this.paginationData.total = res.result.total;
          });
      },
      onPaginationChange(current, pageSize) {
        this.paginationData.current = current;
        this.paginationData.pageSize = pageSize;
        this.getList();
      },
      onNavSwitch(index) {
        this.classIndex = index;
        this.paginationData.current = 1;
        if (this.num !== 2) this.getList();
      },
      onChecked(index) {
        const i = this.checkList.findIndex((m) => m.uuid === this.dataList[index].uuid);
        if (i === -1) {
          this.checkList.push(this.dataList[index]);
        } else {
          this.checkList.splice(i, 1);
        }
      },
      onSumbit(data) {
        if (this.num === 2) {
          this.$emit('onAiMaterial', [data], this.num);
        } else {
          if (this.checkList.length === 0) return message.warning(`请选择图片`);
          this.$emit('onAiMaterial', this.checkList, this.num);
          if (this.num === 0) {
            this.checkList.map((item) => {
              defHttp.get({
                url: `/v1/cms/MaterialMainUse/${item.uuid}`,
              });
            });
          }
        }
        this.previewVisible = false;
      },
      onShow(val) {
        this.previewVisible = true;
        this.checkList = [];
        this.num = val;
        this.previewTitle = this.urls[val][0];
        this.classList = [];
        this.classIndex = 0;
        this.dataList = [];
        if (val === 0) {
          this.getClass().then(() => {
            this.getList();
          });
        } else if (val === 1) {
          this.classList = [
            { name: '应用生图', uuid: 1 },
            { name: '高级生图', uuid: 2 },
          ];
          this.getList();
        } else if (val === 2) {
          defHttp
            .get({
              url: `/v1/cms/MaterialMainFollow`,
              params: {
                type: 3,
              },
            })
            .then((res) => {
              this.classList = res.result.data;
              // this.paginationData.current = res.result.current_page;
              // this.paginationData.total = res.result.total;
            });
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .material {
    .material-left {
      width: 294px;
      height: 577px;
      border-radius: 0 0 0 10px;
      background: #f5f5f5;
    }

    .data-item {
      box-sizing: border-box;
      width: 277px;
      height: 46px;
      margin-top: 13px;
      padding: 0 15px;
      border-radius: 4px;
      color: #222;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      cursor: pointer;

      &.active {
        background: #7472f6;
        color: #fff;
      }
    }

    .material-right {
      padding: 20px;

      .image-list {
        .image-item {
          position: relative;
          width: 216px;
          height: 216px;
          margin: 0 20px 20px 0;
          overflow: hidden;
          border-radius: 9px;
          cursor: pointer;

          &:nth-child(3n) {
            margin-right: 0;
          }

          img {
            width: 216px;
            height: 216px;
            border-radius: 9px;
          }

          &.active {
            border: 4px solid #7472f6;
          }
        }
      }

      .text-list {
        max-height: 550px;
        overflow: hidden auto;

        .text-item {
          margin-bottom: 15px;
          padding: 15px;
          border-radius: 8px;
          background: rgb(189 188 255 / 10%);
          color: #222;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        }
      }
    }
  }
</style>
